@if (body.zertifikatTaetigkeit) {
	<div data-test-id="zertifikatTaetigkeit">{{ body.zertifikatTaetigkeit | enumToLabel: zertifikatTaetigkeitLabel }}</div>
}
